module.exports = __webpack_public_path__ + "img/passport.26d5ae73.png";